var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Pos_main"},[_c('div',{staticClass:"pos_Tmall"},[_c('div',{staticClass:"Tmall_nav"},[_c('p',[_vm._v("By Channel (KRMB) - "+_vm._s(_vm.title))])]),_vm._v(" "),_c('SumTable',{ref:"table"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da0877c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButSecoend2/Summary-IC/Summary.vue
// module id = null
// module chunks = 